<template>
	<SOSlotModal
		:modal-title="'Ringkasan'"
		:modal-id="id"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body class="p-0">
			<div class="d-flex justify-content-center p-x-20 p-y-20" v-if="isLoading">
				<span
					class="spinner-border f-c-blue"
					role="status"
					aria-hidden="true"></span>
			</div>
			<div v-else>
				<div class="modal-body border-bottom">
					<div class="d-flex-between-center align-items-start p-y-8">
						<div class="d-block">
							<div class="f-regular f-16 f-c-black">
								Paket Deposit Terjual
							</div>
							<div class="f-regular f-14 f-c-midgrey">
								Total {{ info.data.total_pembelian | currency }}
							</div>
						</div>
						<div class="f-regular f-16 f-c-black">
							{{ formatRupiah(info.data.jumlah_nota) }} Nota
						</div>
					</div>
				</div>
				<div class="modal-body border-bottom" style="height: 300px; overflow: auto">
					<div class="d-flex p-d-4">
						<img src="@/assets/icons/arrow-down.svg" class="m-r-4" alt="">
						<div class="f-regular f-14 f-c-midgrey">
							Total saldo yang dimiliki konsumen saat ini
						</div>
					</div>
					<div v-for="paket in info.data.rekap_paket_deposit" :key="paket.iddeposit">
						<div class="d-flex-between-center p-y-8">
							<div class="f-regular f-16 f-c-black">{{ paket.nama_deposit }}</div>
							<div class="f-regular f-16 f-c-black">{{ formatRupiah(paket.kuota) }} {{ paket.nama_satuan }}</div>
						</div>
						<div class="separator-line"></div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:modal-footer class="p-0">
			<div class="modal-body border-bottom" v-if="!isLoading">
				<div class="f-regular f-12 f-c-midgrey">
					Data dari <b>{{ formatRupiah(info.data.jumlah_nota) }}</b> Nota,
					mulai {{ $moment(info.data.tanggal_awal_raw).format("DD/MM/YYYY") }}
					hingga {{ $moment(info.data.tanggal_akhir_raw).format("DD/MM/YYYY") }}.
				</div>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "TopupDepositModalRingkasan",
	computed: {
		...mapGetters("depositModule", {
			info: "getInfoTopupDeposit"
		})
	},
	props: {
		isLoading: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			id: "modal-ringkasan-topup-deposit",
		}
	},
	components: {
		SOSlotModal,
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
	}
}
</script>